/**
 * Mirror of `CustomerType` in `backend/src/models/customer.ts` — the numeric
 * values are what `POST /customer-auth/register` expects on the wire.
 *
 * An `as const` object rather than a TS enum: no reverse mapping, tree-shakeable,
 * and the union type below stays assignable from plain numbers we parse back.
 */
export const CUSTOMER_TYPE = {
  individual: 0,
  establishment: 1,
} as const;

export type CustomerType = (typeof CUSTOMER_TYPE)[keyof typeof CUSTOMER_TYPE];

/** Polish labels used by every screen that names an account type. */
export const CUSTOMER_TYPE_LABELS: Readonly<Record<CustomerType, string>> = {
  [CUSTOMER_TYPE.individual]: 'klient indywidualny',
  [CUSTOMER_TYPE.establishment]: 'placówka',
};

/**
 * The account type that is NOT the given one. Used to phrase the 412 collision
 * message without reading the response body: the backend deliberately answers a
 * flattened `{ message, statusCode }` (global HttpExceptionFilter), so the status
 * alone is the contract — and with exactly two types the other one is implied by
 * what the customer picked.
 */
export function otherCustomerType(type: CustomerType): CustomerType {
  return type === CUSTOMER_TYPE.individual
    ? CUSTOMER_TYPE.establishment
    : CUSTOMER_TYPE.individual;
}
